import { render } from "./AddOffrePage.vue?vue&type=template&id=89f3678a&ts=true"
import script from "./AddOffrePage.vue?vue&type=script&lang=ts"
export * from "./AddOffrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__